import { connectionCloseHandler } from "../connectionCloseHandler";
import { connectWithSubscriptions } from "../connectWithSubscriptions";
import { connectionStore } from "../../stores/ConnectionStore";
const ADDITIONAL_DELAY = 1000;
export function buildCloseHandler(connectionName, store) {
    return function (event) {
        let res = [false, -1];
        const conn = connectionStore.get(connectionName);
        if (conn) {
            res = connectionCloseHandler(ADDITIONAL_DELAY, connectWithSubscriptions.bind(undefined, conn, store), event);
        }
        return res;
    };
}
//# sourceMappingURL=buildCloseHandler.js.map